import * as React from 'react';

function SvgDeposit(props) {
  return (
    <svg viewBox="0 0 57 61" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none">
        <path
          d="M50.341 10.519h-3.287A4.913 4.913 0 0042.35 7H21.543a4.913 4.913 0 00-4.705 3.518h-3.287a6.52 6.52 0 00-6.513 6.512v36.79a6.52 6.52 0 006.513 6.514h36.79a6.52 6.52 0 006.513-6.513v-36.79a6.52 6.52 0 00-6.513-6.513z"
          fill="#E2F4F2"
        />
        <path
          d="M35.35 0a4.913 4.913 0 014.704 3.519h3.287a6.52 6.52 0 016.513 6.513v36.79a6.52 6.52 0 01-6.513 6.513H6.551a6.52 6.52 0 01-6.513-6.513v-36.79a6.52 6.52 0 016.513-6.513h3.287A4.913 4.913 0 0114.543 0zM9.838 6.826H6.551a3.21 3.21 0 00-3.206 3.207v36.79a3.21 3.21 0 003.206 3.206h36.79a3.21 3.21 0 003.207-3.206v-36.79a3.21 3.21 0 00-3.207-3.207h-3.287a4.913 4.913 0 01-4.704 3.518H14.543a4.913 4.913 0 01-4.705-3.518zM35.612 18.97l2.338 2.337-17.746 17.746-8.262-8.262 2.338-2.338 5.924 5.924L35.612 18.97zM35.35 3.307H14.543a1.6 1.6 0 00-1.599 1.598v.534a1.6 1.6 0 001.599 1.598H35.35a1.6 1.6 0 001.598-1.598v-.534a1.6 1.6 0 00-1.598-1.598z"
          fill="#38B2A6"
        />
      </g>
    </svg>
  );
}

export default SvgDeposit;
